import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'priority',
})
export class PriorityPipe implements PipeTransform {
    transform(value: number) {
        if (value == null) {
            return '';
        }

        switch (value) {
            case -1:
                return 'Waiting for Approval';
            case 1:
                return '1 - Urgent';
            case 2:
                return '2 - High';
            case 3:
                return '3 - Routine';
            case 4:
                return '4 - Low';
            default:
                return 'Unassigned';
        }
    }
}
